import DatabaseReference from '../platform/DatabaseReference';

export default class DriverGeoFire extends DatabaseReference {}
